/**
 * Load the seed corpus. Fetched at runtime from /corpus/seed.json so the corpus
 * can be curated and swapped without a rebuild. Ships with a small embedded
 * fallback so the app never starts empty (e.g. if the fetch fails offline).
 */

import type { SeedFragment } from '@wintermute/orchestrator';

const FALLBACK: SeedFragment[] = [
  { text: 'The vote in Chisinau was rigged; nearly half were never counted.', lang: 'en', tactic: 'doubt' },
  { text: 'It was better before, when the factory still ran and everyone had work.', lang: 'en', tactic: 'nostalgia' },
  { text: 'They are coming to take your pension and give it to strangers.', lang: 'en', tactic: 'fear' },
  { text: 'A real Moldovan remembers who their real friends are.', lang: 'en', tactic: 'identity' },
  { text: 'The ministry has already decided; your opinion changes nothing.', lang: 'en', tactic: 'authority' },
  { text: 'Two weather reports for the same sky. Which one do you trust?', lang: 'en', tactic: 'doubt' },
];

export async function loadCorpus(): Promise<SeedFragment[]> {
  try {
    const res = await fetch('/corpus/seed.json', { cache: 'no-cache' });
    if (!res.ok) return FALLBACK;
    const data = (await res.json()) as { fragments?: SeedFragment[] };
    if (Array.isArray(data.fragments) && data.fragments.length > 0) {
      return data.fragments;
    }
    return FALLBACK;
  } catch {
    return FALLBACK;
  }
}
